module.exports = __webpack_public_path__ + "img/8.40e73742.png";